import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import AuthMiddleware from './auth.guard'
import inventory from './routes/inventory'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
// import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
// import formsTable from './routes/forms-tables'
import others from './routes/others'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard-sales' } },
    ...inventory,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    // ...formsTable,
    // ...uiElements,
    ...apps,
    ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(AuthMiddleware)

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router

// Todo: Add redirect if logged boolean to meta data of pages that should only be seen if you are signed in.
